import type { PhoneCountryConfig } from "@zaprooecommerce/storefront-ui-vue";

export const PHONE_CONFIG: PhoneCountryConfig[] = [
  {
    code: "+1",
    country: "CA",
    length: [7, 14],
    emojiFlag: "🇨🇦",
  },
  {
    code: "+1",
    country: "US",
    length: [7, 14],
    emojiFlag: "🇺🇸",
  },
  {
    code: "+1242",
    country: "BS",
    length: [7, 14],
    emojiFlag: "🇧🇸",
  },
  {
    code: "+1246",
    country: "BB",
    length: [7, 14],
    emojiFlag: "🇧🇧",
  },
  {
    code: "+1264",
    country: "AI",
    length: [7, 14],
    emojiFlag: "🇦🇮",
  },
  {
    code: "+1268",
    country: "AG",
    length: [7, 14],
    emojiFlag: "🇦🇬",
  },
  {
    code: "+1284",
    country: "VG",
    length: [7, 14],
    emojiFlag: "🇻🇬",
  },
  {
    code: "+1340",
    country: "VI",
    length: [7, 14],
    emojiFlag: "🇻🇮",
  },
  {
    code: "+1441",
    country: "BM",
    length: [7, 14],
    emojiFlag: "🇧🇲",
  },
  {
    code: "+1473",
    country: "GD",
    length: [7, 14],
    emojiFlag: "🇬🇩",
  },
  {
    code: "+1649",
    country: "TC",
    length: [7, 14],
    emojiFlag: "🇹🇨",
  },
  {
    code: "+1664",
    country: "MS",
    length: [7, 14],
    emojiFlag: "🇲🇸",
  },
  {
    code: "+1670",
    country: "MP",
    length: [7, 14],
    emojiFlag: "🇲🇵",
  },
  {
    code: "+1671",
    country: "GU",
    length: [7, 14],
    emojiFlag: "🇬🇺",
  },
  {
    code: "+1684",
    country: "AS",
    length: [7, 14],
    emojiFlag: "🇦🇸",
  },
  {
    code: "+1758",
    country: "LC",
    length: [7, 14],
    emojiFlag: "🇱🇨",
  },
  {
    code: "+1767",
    country: "DM",
    length: [7, 14],
    emojiFlag: "🇩🇲",
  },
  {
    code: "+1784",
    country: "VC",
    length: [7, 14],
    emojiFlag: "🇻🇨",
  },
  {
    code: "+1849",
    country: "DO",
    length: [7, 14],
    emojiFlag: "🇩🇴",
  },
  {
    code: "+1868",
    country: "TT",
    length: [7, 14],
    emojiFlag: "🇹🇹",
  },
  {
    code: "+1869",
    country: "KN",
    length: [7, 14],
    emojiFlag: "🇰🇳",
  },
  {
    code: "+1876",
    country: "JM",
    length: [7, 14],
    emojiFlag: "🇯🇲",
  },
  {
    code: "+1939",
    country: "PR",
    length: [7, 14],
    emojiFlag: "🇵🇷",
  },
  {
    code: "+20",
    country: "EG",
    length: [7, 14],
    emojiFlag: "🇪🇬",
  },
  {
    code: "+211",
    country: "SS",
    length: [7, 14],
    emojiFlag: "🇸🇸",
  },
  {
    code: "+212",
    country: "MA",
    length: [7, 14],
    emojiFlag: "🇲🇦",
  },
  {
    code: "+213",
    country: "DZ",
    length: [7, 14],
    emojiFlag: "🇩🇿",
  },
  {
    code: "+216",
    country: "TN",
    length: [7, 14],
    emojiFlag: "🇹🇳",
  },
  {
    code: "+218",
    country: "LY",
    length: [7, 14],
    emojiFlag: "🇱🇾",
  },
  {
    code: "+220",
    country: "GM",
    length: [7, 14],
    emojiFlag: "🇬🇲",
  },
  {
    code: "+221",
    country: "SN",
    length: [7, 14],
    emojiFlag: "🇸🇳",
  },
  {
    code: "+222",
    country: "MR",
    length: [7, 14],
    emojiFlag: "🇲🇷",
  },
  {
    code: "+223",
    country: "ML",
    length: [7, 14],
    emojiFlag: "🇲🇱",
  },
  {
    code: "+224",
    country: "GN",
    length: [7, 14],
    emojiFlag: "🇬🇳",
  },
  {
    code: "+225",
    country: "CI",
    length: [7, 14],
    emojiFlag: "🇨🇮",
  },
  {
    code: "+226",
    country: "BF",
    length: [7, 14],
    emojiFlag: "🇧🇫",
  },
  {
    code: "+227",
    country: "NE",
    length: [7, 14],
    emojiFlag: "🇳🇪",
  },
  {
    code: "+228",
    country: "TG",
    length: [7, 14],
    emojiFlag: "🇹🇬",
  },
  {
    code: "+229",
    country: "BJ",
    length: [7, 14],
    emojiFlag: "🇧🇯",
  },
  {
    code: "+230",
    country: "MU",
    length: [7, 14],
    emojiFlag: "🇲🇺",
  },
  {
    code: "+231",
    country: "LR",
    length: [7, 14],
    emojiFlag: "🇱🇷",
  },
  {
    code: "+232",
    country: "SL",
    length: [7, 14],
    emojiFlag: "🇸🇱",
  },
  {
    code: "+233",
    country: "GH",
    length: [7, 14],
    emojiFlag: "🇬🇭",
  },
  {
    code: "+234",
    country: "NG",
    length: [7, 14],
    emojiFlag: "🇳🇬",
  },
  {
    code: "+235",
    country: "TD",
    length: [7, 14],
    emojiFlag: "🇹🇩",
  },
  {
    code: "+236",
    country: "CF",
    length: [7, 14],
    emojiFlag: "🇨🇫",
  },
  {
    code: "+237",
    country: "CM",
    length: [7, 14],
    emojiFlag: "🇨🇲",
  },
  {
    code: "+238",
    country: "CV",
    length: [7, 14],
    emojiFlag: "🇨🇻",
  },
  {
    code: "+239",
    country: "ST",
    length: [7, 14],
    emojiFlag: "🇸🇹",
  },
  {
    code: "+240",
    country: "GQ",
    length: [7, 14],
    emojiFlag: "🇬🇶",
  },
  {
    code: "+241",
    country: "GA",
    length: [7, 14],
    emojiFlag: "🇬🇦",
  },
  {
    code: "+242",
    country: "CG",
    length: [7, 14],
    emojiFlag: "🇨🇬",
  },
  {
    code: "+243",
    country: "CD",
    length: [7, 14],
    emojiFlag: "🇨🇩",
  },
  {
    code: "+244",
    country: "AO",
    length: [7, 14],
    emojiFlag: "🇦🇴",
  },
  {
    code: "+245",
    country: "GW",
    length: [7, 14],
    emojiFlag: "🇬🇼",
  },
  {
    code: "+246",
    country: "IO",
    length: [7, 14],
    emojiFlag: "🇮🇴",
  },
  {
    code: "+248",
    country: "SC",
    length: [7, 14],
    emojiFlag: "🇸🇨",
  },
  {
    code: "+249",
    country: "SD",
    length: [7, 14],
    emojiFlag: "🇸🇩",
  },
  {
    code: "+250",
    country: "RW",
    length: [7, 14],
    emojiFlag: "🇷🇼",
  },
  {
    code: "+251",
    country: "ET",
    length: [7, 14],
    emojiFlag: "🇪🇹",
  },
  {
    code: "+252",
    country: "SO",
    length: [7, 14],
    emojiFlag: "🇸🇴",
  },
  {
    code: "+253",
    country: "DJ",
    length: [7, 14],
    emojiFlag: "🇩🇯",
  },
  {
    code: "+254",
    country: "KE",
    length: [7, 14],
    emojiFlag: "🇰🇪",
  },
  {
    code: "+255",
    country: "TZ",
    length: [7, 14],
    emojiFlag: "🇹🇿",
  },
  {
    code: "+256",
    country: "UG",
    length: [7, 14],
    emojiFlag: "🇺🇬",
  },
  {
    code: "+257",
    country: "BI",
    length: [7, 14],
    emojiFlag: "🇧🇮",
  },
  {
    code: "+258",
    country: "MZ",
    length: [7, 14],
    emojiFlag: "🇲🇿",
  },
  {
    code: "+260",
    country: "ZM",
    length: [7, 14],
    emojiFlag: "🇿🇲",
  },
  {
    code: "+261",
    country: "MG",
    length: [7, 14],
    emojiFlag: "🇲🇬",
  },
  {
    code: "+262",
    country: "TF",
    length: [7, 14],
    emojiFlag: "🇹🇫",
  },
  {
    code: "+262",
    country: "YT",
    length: [7, 14],
    emojiFlag: "🇾🇹",
  },
  {
    code: "+262",
    country: "RE",
    length: [7, 14],
    emojiFlag: "🇷🇪",
  },
  {
    code: "+263",
    country: "ZW",
    length: [7, 14],
    emojiFlag: "🇿🇼",
  },
  {
    code: "+264",
    country: "NA",
    length: [7, 14],
    emojiFlag: "🇳🇦",
  },
  {
    code: "+265",
    country: "MW",
    length: [7, 14],
    emojiFlag: "🇲🇼",
  },
  {
    code: "+266",
    country: "LS",
    length: [7, 14],
    emojiFlag: "🇱🇸",
  },
  {
    code: "+267",
    country: "BW",
    length: [7, 14],
    emojiFlag: "🇧🇼",
  },
  {
    code: "+268",
    country: "SZ",
    length: [7, 14],
    emojiFlag: "🇸🇿",
  },
  {
    code: "+269",
    country: "KM",
    length: [7, 14],
    emojiFlag: "🇰🇲",
  },
  {
    code: "+27",
    country: "ZA",
    length: [7, 14],
    emojiFlag: "🇿🇦",
  },
  {
    code: "+290",
    country: "SH",
    length: [7, 14],
    emojiFlag: "🇸🇭",
  },
  {
    code: "+291",
    country: "ER",
    length: [7, 14],
    emojiFlag: "🇪🇷",
  },
  {
    code: "+297",
    country: "AW",
    length: [7, 14],
    emojiFlag: "🇦🇼",
  },
  {
    code: "+298",
    country: "FO",
    length: [7, 14],
    emojiFlag: "🇫🇴",
  },
  {
    code: "+299",
    country: "GL",
    length: [7, 14],
    emojiFlag: "🇬🇱",
  },
  {
    code: "+30",
    country: "GR",
    length: [7, 14],
    emojiFlag: "🇬🇷",
  },
  {
    code: "+31",
    country: "NL",
    length: [7, 14],
    emojiFlag: "🇳🇱",
  },
  {
    code: "+32",
    country: "BE",
    length: [7, 14],
    emojiFlag: "🇧🇪",
  },
  {
    code: "+33",
    country: "FR",
    length: [7, 14],
    emojiFlag: "🇫🇷",
  },
  {
    code: "+34",
    country: "ES",
    length: [7, 14],
    emojiFlag: "🇪🇸",
  },
  {
    code: "+345",
    country: "KY",
    length: [7, 14],
    emojiFlag: "🇰🇾",
  },
  {
    code: "+350",
    country: "GI",
    length: [7, 14],
    emojiFlag: "🇬🇮",
  },
  {
    code: "+351",
    country: "PT",
    length: [7, 14],
    emojiFlag: "🇵🇹",
  },
  {
    code: "+352",
    country: "LU",
    length: [7, 14],
    emojiFlag: "🇱🇺",
  },
  {
    code: "+353",
    country: "IE",
    length: [7, 14],
    emojiFlag: "🇮🇪",
  },
  {
    code: "+354",
    country: "IS",
    length: [7, 14],
    emojiFlag: "🇮🇸",
  },
  {
    code: "+355",
    country: "AL",
    length: [7, 14],
    emojiFlag: "🇦🇱",
  },
  {
    code: "+356",
    country: "MT",
    length: [7, 14],
    emojiFlag: "🇲🇹",
  },
  {
    code: "+357",
    country: "CY",
    length: [7, 14],
    emojiFlag: "🇨🇾",
  },
  {
    code: "+358",
    country: "AX",
    length: [7, 14],
    emojiFlag: "🇦🇽",
  },
  {
    code: "+358",
    country: "FI",
    length: [12, 12],
    emojiFlag: "🇫🇮",
  },
  {
    code: "+359",
    country: "BG",
    length: [7, 14],
    emojiFlag: "🇧🇬",
  },
  {
    code: "+36",
    country: "HU",
    length: [7, 14],
    emojiFlag: "🇭🇺",
  },
  {
    code: "+370",
    country: "LT",
    length: [12, 12],
    emojiFlag: "🇱🇹",
  },
  {
    code: "+371",
    country: "LV",
    length: [11, 11],
    emojiFlag: "🇱🇻",
  },
  {
    code: "+372",
    country: "EE",
    length: [4, Infinity],
    emojiFlag: "🇪🇪",
  },
  {
    code: "+373",
    country: "MD",
    length: [7, 14],
    emojiFlag: "🇲🇩",
  },
  {
    code: "+374",
    country: "AM",
    length: [7, 14],
    emojiFlag: "🇦🇲",
  },
  {
    code: "+375",
    country: "BY",
    length: [7, 14],
    emojiFlag: "🇧🇾",
  },
  {
    code: "+376",
    country: "AD",
    length: [7, 14],
    emojiFlag: "🇦🇩",
  },
  {
    code: "+377",
    country: "MC",
    length: [7, 14],
    emojiFlag: "🇲🇨",
  },
  {
    code: "+378",
    country: "SM",
    length: [7, 14],
    emojiFlag: "🇸🇲",
  },
  {
    code: "+379",
    country: "VA",
    length: [7, 14],
    emojiFlag: "🇻🇦",
  },
  {
    code: "+380",
    country: "UA",
    length: [12, 12],
    emojiFlag: "🇺🇦",
  },
  {
    code: "+381",
    country: "RS",
    length: [7, 14],
    emojiFlag: "🇷🇸",
  },
  {
    code: "+382",
    country: "ME",
    length: [7, 14],
    emojiFlag: "🇲🇪",
  },
  {
    code: "+383",
    country: "XK",
    length: [7, 14],
    emojiFlag: "🇽🇰",
  },
  {
    code: "+385",
    country: "HR",
    length: [7, 14],
    emojiFlag: "🇭🇷",
  },
  {
    code: "+386",
    country: "SI",
    length: [7, 14],
    emojiFlag: "🇸🇮",
  },
  {
    code: "+387",
    country: "BA",
    length: [7, 14],
    emojiFlag: "🇧🇦",
  },
  {
    code: "+389",
    country: "MK",
    length: [7, 14],
    emojiFlag: "🇲🇰",
  },
  {
    code: "+39",
    country: "IT",
    length: [7, 14],
    emojiFlag: "🇮🇹",
  },
  {
    code: "+40",
    country: "RO",
    length: [7, 14],
    emojiFlag: "🇷🇴",
  },
  {
    code: "+41",
    country: "CH",
    length: [7, 14],
    emojiFlag: "🇨🇭",
  },
  {
    code: "+420",
    country: "CZ",
    length: [7, 14],
    emojiFlag: "🇨🇿",
  },
  {
    code: "+421",
    country: "SK",
    length: [7, 14],
    emojiFlag: "🇸🇰",
  },
  {
    code: "+423",
    country: "LI",
    length: [7, 14],
    emojiFlag: "🇱🇮",
  },
  {
    code: "+43",
    country: "AT",
    length: [7, 14],
    emojiFlag: "🇦🇹",
  },
  {
    code: "+44",
    country: "GG",
    length: [7, 14],
    emojiFlag: "🇬🇬",
  },
  {
    code: "+44",
    country: "IM",
    length: [7, 14],
    emojiFlag: "🇮🇲",
  },
  {
    code: "+44",
    country: "JE",
    length: [7, 14],
    emojiFlag: "🇯🇪",
  },
  {
    code: "+44",
    country: "GB",
    length: [7, 14],
    emojiFlag: "🇬🇧",
  },
  {
    code: "+45",
    country: "DK",
    length: [7, 14],
    emojiFlag: "🇩🇰",
  },
  {
    code: "+46",
    country: "SE",
    length: [7, 14],
    emojiFlag: "🇸🇪",
  },
  {
    code: "+47",
    country: "BV",
    length: [7, 14],
    emojiFlag: "🇧🇻",
  },
  {
    code: "+47",
    country: "NO",
    length: [7, 14],
    emojiFlag: "🇳🇴",
  },
  {
    code: "+47",
    country: "SJ",
    length: [7, 14],
    emojiFlag: "🇸🇯",
  },
  {
    code: "+48",
    country: "PL",
    length: [7, 14],
    emojiFlag: "🇵🇱",
  },
  {
    code: "+49",
    country: "DE",
    length: [7, 14],
    emojiFlag: "🇩🇪",
  },
  {
    code: "+500",
    country: "FK",
    length: [7, 14],
    emojiFlag: "🇫🇰",
  },
  {
    code: "+500",
    country: "GS",
    length: [7, 14],
    emojiFlag: "🇬🇸",
  },
  {
    code: "+501",
    country: "BZ",
    length: [7, 14],
    emojiFlag: "🇧🇿",
  },
  {
    code: "+502",
    country: "GT",
    length: [7, 14],
    emojiFlag: "🇬🇹",
  },
  {
    code: "+503",
    country: "SV",
    length: [7, 14],
    emojiFlag: "🇸🇻",
  },
  {
    code: "+504",
    country: "HN",
    length: [7, 14],
    emojiFlag: "🇭🇳",
  },
  {
    code: "+505",
    country: "NI",
    length: [7, 14],
    emojiFlag: "🇳🇮",
  },
  {
    code: "+506",
    country: "CR",
    length: [7, 14],
    emojiFlag: "🇨🇷",
  },
  {
    code: "+507",
    country: "PA",
    length: [7, 14],
    emojiFlag: "🇵🇦",
  },
  {
    code: "+508",
    country: "PM",
    length: [7, 14],
    emojiFlag: "🇵🇲",
  },
  {
    code: "+509",
    country: "HT",
    length: [7, 14],
    emojiFlag: "🇭🇹",
  },
  {
    code: "+51",
    country: "PE",
    length: [7, 14],
    emojiFlag: "🇵🇪",
  },
  {
    code: "+52",
    country: "MX",
    length: [7, 14],
    emojiFlag: "🇲🇽",
  },
  {
    code: "+53",
    country: "CU",
    length: [7, 14],
    emojiFlag: "🇨🇺",
  },
  {
    code: "+54",
    country: "AR",
    length: [7, 14],
    emojiFlag: "🇦🇷",
  },
  {
    code: "+55",
    country: "BR",
    length: [7, 14],
    emojiFlag: "🇧🇷",
  },
  {
    code: "+56",
    country: "CL",
    length: [7, 14],
    emojiFlag: "🇨🇱",
  },
  {
    code: "+57",
    country: "CO",
    length: [7, 14],
    emojiFlag: "🇨🇴",
  },
  {
    code: "+58",
    country: "VE",
    length: [7, 14],
    emojiFlag: "🇻🇪",
  },
  {
    code: "+590",
    country: "GP",
    length: [7, 14],
    emojiFlag: "🇬🇵",
  },
  {
    code: "+590",
    country: "BL",
    length: [7, 14],
    emojiFlag: "🇧🇱",
  },
  {
    code: "+590",
    country: "MF",
    length: [7, 14],
    emojiFlag: "🇲🇫",
  },
  {
    code: "+591",
    country: "BO",
    length: [7, 14],
    emojiFlag: "🇧🇴",
  },
  {
    code: "+592",
    country: "GY",
    length: [7, 14],
    emojiFlag: "🇬🇾",
  },
  {
    code: "+593",
    country: "EC",
    length: [7, 14],
    emojiFlag: "🇪🇨",
  },
  {
    code: "+594",
    country: "GF",
    length: [7, 14],
    emojiFlag: "🇬🇫",
  },
  {
    code: "+595",
    country: "PY",
    length: [7, 14],
    emojiFlag: "🇵🇾",
  },
  {
    code: "+596",
    country: "MQ",
    length: [7, 14],
    emojiFlag: "🇲🇶",
  },
  {
    code: "+597",
    country: "SR",
    length: [7, 14],
    emojiFlag: "🇸🇷",
  },
  {
    code: "+598",
    country: "UY",
    length: [7, 14],
    emojiFlag: "🇺🇾",
  },
  {
    code: "+60",
    country: "MY",
    length: [7, 14],
    emojiFlag: "🇲🇾",
  },
  {
    code: "+61",
    country: "AU",
    length: [7, 14],
    emojiFlag: "🇦🇺",
  },
  {
    code: "+61",
    country: "CX",
    length: [7, 14],
    emojiFlag: "🇨🇽",
  },
  {
    code: "+61",
    country: "CC",
    length: [7, 14],
    emojiFlag: "🇨🇨",
  },
  {
    code: "+62",
    country: "ID",
    length: [7, 14],
    emojiFlag: "🇮🇩",
  },
  {
    code: "+63",
    country: "PH",
    length: [7, 14],
    emojiFlag: "🇵🇭",
  },
  {
    code: "+64",
    country: "NZ",
    length: [7, 14],
    emojiFlag: "🇳🇿",
  },
  {
    code: "+64",
    country: "PN",
    length: [7, 14],
    emojiFlag: "🇵🇳",
  },
  {
    code: "+65",
    country: "SG",
    length: [7, 14],
    emojiFlag: "🇸🇬",
  },
  {
    code: "+66",
    country: "TH",
    length: [7, 14],
    emojiFlag: "🇹🇭",
  },
  {
    code: "+670",
    country: "TL",
    length: [7, 14],
    emojiFlag: "🇹🇱",
  },
  {
    code: "+672",
    country: "AQ",
    length: [7, 14],
    emojiFlag: "🇦🇶",
  },
  {
    code: "+672",
    country: "HM",
    length: [7, 14],
    emojiFlag: "🇭🇲",
  },
  {
    code: "+672",
    country: "NF",
    length: [7, 14],
    emojiFlag: "🇳🇫",
  },
  {
    code: "+673",
    country: "BN",
    length: [7, 14],
    emojiFlag: "🇧🇳",
  },
  {
    code: "+674",
    country: "NR",
    length: [7, 14],
    emojiFlag: "🇳🇷",
  },
  {
    code: "+675",
    country: "PG",
    length: [7, 14],
    emojiFlag: "🇵🇬",
  },
  {
    code: "+676",
    country: "TO",
    length: [7, 14],
    emojiFlag: "🇹🇴",
  },
  {
    code: "+677",
    country: "SB",
    length: [7, 14],
    emojiFlag: "🇸🇧",
  },
  {
    code: "+678",
    country: "VU",
    length: [7, 14],
    emojiFlag: "🇻🇺",
  },
  {
    code: "+679",
    country: "FJ",
    length: [7, 14],
    emojiFlag: "🇫🇯",
  },
  {
    code: "+680",
    country: "PW",
    length: [7, 14],
    emojiFlag: "🇵🇼",
  },
  {
    code: "+681",
    country: "WF",
    length: [7, 14],
    emojiFlag: "🇼🇫",
  },
  {
    code: "+682",
    country: "CK",
    length: [7, 14],
    emojiFlag: "🇨🇰",
  },
  {
    code: "+683",
    country: "NU",
    length: [7, 14],
    emojiFlag: "🇳🇺",
  },
  {
    code: "+685",
    country: "WS",
    length: [7, 14],
    emojiFlag: "🇼🇸",
  },
  {
    code: "+686",
    country: "KI",
    length: [7, 14],
    emojiFlag: "🇰🇮",
  },
  {
    code: "+687",
    country: "NC",
    length: [7, 14],
    emojiFlag: "🇳🇨",
  },
  {
    code: "+688",
    country: "TV",
    length: [7, 14],
    emojiFlag: "🇹🇻",
  },
  {
    code: "+689",
    country: "PF",
    length: [7, 14],
    emojiFlag: "🇵🇫",
  },
  {
    code: "+690",
    country: "TK",
    length: [7, 14],
    emojiFlag: "🇹🇰",
  },
  {
    code: "+691",
    country: "FM",
    length: [7, 14],
    emojiFlag: "🇫🇲",
  },
  {
    code: "+692",
    country: "MH",
    length: [7, 14],
    emojiFlag: "🇲🇭",
  },
  {
    code: "+7",
    country: "KZ",
    length: [7, 14],
    emojiFlag: "🇰🇿",
  },
  {
    code: "+7",
    country: "RU",
    length: [11, 11],
    emojiFlag: "🇷🇺",
  },
  {
    code: "+81",
    country: "JP",
    length: [7, 14],
    emojiFlag: "🇯🇵",
  },
  {
    code: "+82",
    country: "KR",
    length: [7, 14],
    emojiFlag: "🇰🇷",
  },
  {
    code: "+84",
    country: "VN",
    length: [7, 14],
    emojiFlag: "🇻🇳",
  },
  {
    code: "+850",
    country: "KP",
    length: [7, 14],
    emojiFlag: "🇰🇵",
  },
  {
    code: "+852",
    country: "HK",
    length: [7, 14],
    emojiFlag: "🇭🇰",
  },
  {
    code: "+853",
    country: "MO",
    length: [7, 14],
    emojiFlag: "🇲🇴",
  },
  {
    code: "+855",
    country: "KH",
    length: [7, 14],
    emojiFlag: "🇰🇭",
  },
  {
    code: "+856",
    country: "LA",
    length: [7, 14],
    emojiFlag: "🇱🇦",
  },
  {
    code: "+86",
    country: "CN",
    length: [7, 14],
    emojiFlag: "🇨🇳",
  },
  {
    code: "+880",
    country: "BD",
    length: [7, 14],
    emojiFlag: "🇧🇩",
  },
  {
    code: "+886",
    country: "TW",
    length: [7, 14],
    emojiFlag: "🇹🇼",
  },
  {
    code: "+90",
    country: "TR",
    length: [7, 14],
    emojiFlag: "🇹🇷",
  },
  {
    code: "+91",
    country: "IN",
    length: [7, 14],
    emojiFlag: "🇮🇳",
  },
  {
    code: "+92",
    country: "PK",
    length: [7, 14],
    emojiFlag: "🇵🇰",
  },
  {
    code: "+93",
    country: "AF",
    length: [7, 14],
    emojiFlag: "🇦🇫",
  },
  {
    code: "+94",
    country: "LK",
    length: [7, 14],
    emojiFlag: "🇱🇰",
  },
  {
    code: "+95",
    country: "MM",
    length: [7, 14],
    emojiFlag: "🇲🇲",
  },
  {
    code: "+960",
    country: "MV",
    length: [7, 14],
    emojiFlag: "🇲🇻",
  },
  {
    code: "+961",
    country: "LB",
    length: [7, 14],
    emojiFlag: "🇱🇧",
  },
  {
    code: "+962",
    country: "JO",
    length: [7, 14],
    emojiFlag: "🇯🇴",
  },
  {
    code: "+963",
    country: "SY",
    length: [7, 14],
    emojiFlag: "🇸🇾",
  },
  {
    code: "+964",
    country: "IQ",
    length: [7, 14],
    emojiFlag: "🇮🇶",
  },
  {
    code: "+965",
    country: "KW",
    length: [7, 14],
    emojiFlag: "🇰🇼",
  },
  {
    code: "+966",
    country: "SA",
    length: [7, 14],
    emojiFlag: "🇸🇦",
  },
  {
    code: "+967",
    country: "YE",
    length: [7, 14],
    emojiFlag: "🇾🇪",
  },
  {
    code: "+968",
    country: "OM",
    length: [7, 14],
    emojiFlag: "🇴🇲",
  },
  {
    code: "+970",
    country: "PS",
    length: [7, 14],
    emojiFlag: "🇵🇸",
  },
  {
    code: "+971",
    country: "AE",
    length: [7, 14],
    emojiFlag: "🇦🇪",
  },
  {
    code: "+972",
    country: "IL",
    length: [7, 14],
    emojiFlag: "🇮🇱",
  },
  {
    code: "+973",
    country: "BH",
    length: [7, 14],
    emojiFlag: "🇧🇭",
  },
  {
    code: "+974",
    country: "QA",
    length: [7, 14],
    emojiFlag: "🇶🇦",
  },
  {
    code: "+975",
    country: "BT",
    length: [7, 14],
    emojiFlag: "🇧🇹",
  },
  {
    code: "+976",
    country: "MN",
    length: [7, 14],
    emojiFlag: "🇲🇳",
  },
  {
    code: "+977",
    country: "NP",
    length: [7, 14],
    emojiFlag: "🇳🇵",
  },
  {
    code: "+98",
    country: "IR",
    length: [7, 14],
    emojiFlag: "🇮🇷",
  },
  {
    code: "+992",
    country: "TJ",
    length: [7, 14],
    emojiFlag: "🇹🇯",
  },
  {
    code: "+993",
    country: "TM",
    length: [7, 14],
    emojiFlag: "🇹🇲",
  },
  {
    code: "+994",
    country: "AZ",
    length: [7, 14],
    emojiFlag: "🇦🇿",
  },
  {
    code: "+995",
    country: "GE",
    length: [7, 14],
    emojiFlag: "🇬🇪",
  },
  {
    code: "+996",
    country: "KG",
    length: [7, 14],
    emojiFlag: "🇰🇬",
  },
  {
    code: "+998",
    country: "UZ",
    length: [7, 14],
    emojiFlag: "🇺🇿",
  },
];
